// ============================================================
// THE DISPLAY'S AMBIENT MARK ON THE GROUND (plan design-gaps, T4; the display
// page): the actor's sight - a 60 degree wedge, 14 m long, toward the one
// they target. (The range rings at 5, 10 and 20 m went on the user's word,
// 2026-10-21: "please remove the 5/10/20m range rings".) (The frame's
// scanlines and vignette are the scene's; the heat under the other
// side is the markers'.)
//
// Ground points, for the renderer to project. Pure. Zero React dependency.
// ============================================================

import type { Vec3 } from '../battlefield/types';
import { bearingBetween, headingPoint } from '../battlefield/facing';

type Place = { x: number; z: number; elevation: number };

/** The sight wedge's half-angle and reach, and the points along its arc. */
const SIGHT_HALF_DEG = 30;
const SIGHT_M = 14;
const ARC_POINTS = 13;

/**
 * The sight wedge from `from` toward `toward`: its apex, then its arc, on the ground under the actor. `turn` swings
 * it that many degrees off the line (Observe's sweep, Z1); `reach` its length, metres.
 */
export function sightWedge(
  from: Place,
  toward: { x: number; z: number },
  { turn = 0, reach = SIGHT_M }: { turn?: number; reach?: number } = {},
): Vec3[] {
  const bearing = bearingBetween(from, toward) + turn;
  const y = from.elevation;
  const arc = Array.from({ length: ARC_POINTS }, (_, i) => {
    const deg = bearing - SIGHT_HALF_DEG + (2 * SIGHT_HALF_DEG * i) / (ARC_POINTS - 1);
    return { ...headingPoint(from, deg, reach), y };
  });
  return [{ x: from.x, y, z: from.z }, ...arc];
}
